import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
    marginRight: theme.spacing(1),
    cursor: 'pointer',
  background:'#eceff1', // Background color gradient
  //background:'red', // Background color gradient
  };
});
const BreadcrumbsComponent = () => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const paths = location.pathname.split('/').filter((path) => path !== '');
    const newBreadcrumbs = paths.map((path, index) => ({
      path: `/${paths.slice(0, index + 1).join('/')}`,
      label: path.replace(/_/g, ' ').toUpperCase(),
    }));
    setBreadcrumbs(newBreadcrumbs);
  }, [location]);

  const handleBreadcrumbClick = (event, path) => {
    event.preventDefault();
    console.info('You clicked a breadcrumb.');
    navigate(path);
  };

  // Conditionally render breadcrumbs only if the pathname is not "/login"
  if (location.pathname === '/Login') {
    return null; // Do not render breadcrumbs on the login page
  }
  if (location.pathname === '/login') {
    return null; // Do not render breadcrumbs on the login page
  }
  
  if(location.pathname === '/siso' || location.pathname === '/ProductDetails_INLUDE'){
	  return null;
  }
  //if (location.pathname === '/ForgetPassword' || location.pathname === '/ResetPassword') {
  //  return null; // Do not render breadcrumbs on the login page
  //}

  return (
    <nav style={{ backgroundImage: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)'}}>
      <Breadcrumbs aria-label="breadcrumb">
        {breadcrumbs.map((breadcrumb, index) => (
          <StyledBreadcrumb
            key={index}
            component="div"
            label={breadcrumb.label}
		
            onClick={(event) => handleBreadcrumbClick(event, breadcrumb.path)}
          />
        ))}
      </Breadcrumbs>
    </nav>
  );
};

export default BreadcrumbsComponent;
